<span *ngFor="let noteSection of noteSections">
  <div [ngClass]="noteSection.noteClass" class="mt-10 mb-10">
    <i [ngClass]="noteSection.iconClass" class="redWarningIcon"></i>
    <strong class="pl-2">{{ noteSection.title }}</strong>
    <span class="pl-2" [innerHTML]="noteSection.body || '' | mdToHtml"></span>
  </div>
</span>
